"use strict";

export default function () {
    const hamburguer = document.querySelector(".hamburguer-menu");
    const close = document.querySelector(".close-menu");
    const menu = document.querySelector(".mobile-menu");
    const btn_contact = document.querySelector(
        ".mobile-menu .contact-us_button"
    );

    hamburguer.addEventListener("click", () => {
        menu.classList.add("active");
    });

    close.addEventListener("click", () => {
        menu.classList.remove("active");
    });

    btn_contact.addEventListener("click", () => {
        menu.classList.remove("active");
    });
}
